interface NetworkConditions {
  type: string | undefined;
  effectiveType: string | undefined;
  downlink: number | undefined;
  isSupported: boolean;
}

export function getNetworkConditions(): NetworkConditions {
  const connection = navigator.connection;
  if (!connection) {
    return { type: undefined, effectiveType: undefined, downlink: undefined, isSupported: false };
  }
  return {
    type: connection.type,
    effectiveType: connection.effectiveType,
    downlink: connection.downlink,
    isSupported: true,
  };
}

export function isCellularConnection(): boolean {
  const connection = navigator.connection;
  return connection?.type === 'cellular';
}

export function isSlowNetwork(): boolean {
  const connection = navigator.connection;
  if (!connection) return false;

  if (connection.type === 'cellular') return true;

  const slowTypes = ['slow-2g', '2g', '3g'];
  if (connection.effectiveType && slowTypes.includes(connection.effectiveType)) return true;

  if (typeof connection.downlink === 'number' && connection.downlink < 2) return true;

  return false;
}
